export default "__VITE_ASSET__DswzrWYS__"